export class Usuario {
    enlargedPhoto?: number;
    fullName?: string;
    userName?: string;
    email?: string;
    position?: string;
    lastAccessToTheSystem?: string;
  }